export default {
  roi_desc: 'ROI: Enable posting objects detected only inside a region of interest',
  rot_desc: 'ROT: Enable detecting and tracking objects only inside a clipping rectangle. You can use this option to reduce CPU load'
};
